import React from 'react';

interface TestimonialProps {
  name: string;
  role: string;
  content: string;
  rating: number;
}

const Testimonial: React.FC<TestimonialProps> = ({ name, role, content, rating }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex mb-4">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-5 h-5 ${i < rating ? 'text-secondary' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
      <p className="text-gray-600 mb-6 italic">"{content}"</p>
      <div className="flex items-center">
        <div className="w-10 h-10 bg-gray-200 rounded-full mr-3 flex items-center justify-center">
          <span className="text-gray-500 font-medium">{name.charAt(0)}</span>
        </div>
        <div>
          <h4 className="font-medium">{name}</h4>
          <p className="text-sm text-gray-500">{role}</p>
        </div>
      </div>
    </div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Ana Silva',
      role: 'Cliente desde 2022',
      content: 'Os tratamentos da BotoHarmony transformaram minha autoestima. Os resultados são naturais e a equipe é extremamente profissional e atenciosa.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Juliana Costa',
      role: 'Cliente desde 2025',
      image: '/assets/img/testimonials/patient-3.jpg',
      content: 'Excelente atendimento e resultados surpreendentes. A toxina botulínica aplicada ficou muito natural, exatamente o que eu queria.',
      rating: 5,
    },
    {
      name: 'Mariana Costa',
      role: 'Cliente desde 2024',
      content: 'Já fiz diversos procedimentos na clínica e sempre saio satisfeita. Os profissionais são muito capacitados e o ambiente é acolhedor.',
      rating: 4,
    },
  ];

  return (
    <section className="py-16 bg-light">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="section-title">O Que Nossos Clientes Dizem</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            A satisfação de nossos clientes é nossa maior recompensa. Confira alguns depoimentos de quem já experimentou nossos tratamentos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Testimonial
              key={index}
              name={testimonial.name}
              role={testimonial.role}
              content={testimonial.content}
              rating={testimonial.rating}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;